export const QA_NAME_LISTING_PROFILE_WIDGET_PORTALS = 'listingPortalLinks'

export const QA_NAME_LISTING_PROFILE_PORTAL_LINK = 'listingProfilePortalLink'

export const QA_NAME_LISTING_PROFILE_PORTAL_ROW = 'listingProfilePortalRow'
